/**
 * BAMBOOVE — "MA NGUOI MOI: TU AP VAO GIO"  (15/10/2026 · H1)
 * ============================================================================
 * KHACH CHOT 15/10/2026: "de email roi thi tu ap san va tru san o gio, va
 *   ap xong thi AN KHOI MA DI (khoi do chiem dien tich)".
 *
 * VI SAO KHONG TU AP CHO MOI KHACH:
 *   · 10% la "moi" de DOI LAY EMAIL. Neu ai cung duoc tu dong giam thi khong con
 *     ly do de khach de lai email => mat tep khach (thu dang gia nhat).
 *   · DO 15/10/2026 tren gio that: ma WELCOME10 KHONG cong don voi uu dai bundle
 *     (Shopify ban thuong chi cho 1 uu dai SAN PHAM moi dong — muon nhieu uu dai
 *     san pham tren cung dong phai co Shopify Plus). Tu 2 doi tro len Shopify
 *     TU CHON uu dai bundle (10/25/30%) va ma khong ap => tu ap chi co tac dung
 *     o don 1 doi. Vi vay phai giu "email = chia khoa", khong phat tran.
 *
 * CACH LAM (4 buoc):
 *   1) Khach DA de email chua?  -> co co `bamboove-popup-da-dang-ky` (do popup ghi),
 *      hoac thay dau "dang ky thanh cong" o bat ky form nao tren trang.
 *      Chua de email => KHONG hien khoi ma (khong co gi de lam).
 *   2) Gio dang co hang chua?   -> gio trong thi chua ap (de luc khach them hang).
 *   3) Ma da ap chua?           -> ap roi thi AN KHOI + thoi.
 *   4) Chua ap => goi /cart/update.js {discount: MA} -> doc lai /cart.js:
 *        · Shopify xac nhan ap duoc (`applicable: true`) => AN KHOI + ve lai ruot gio
 *          (de dong "giam gia" hien ra o phan tong tien).
 *        · Khong ap duoc (thuong la vi uu dai bundle da loi hon) => AN KHOI luon,
 *          khong hua gi them (dung nhu cau FAQ: "he thong tu ap cai loi hon").
 *        · Mang loi / khong chap nhan => HIEN KHOI DU PHONG (co nut Copy/Apply).
 *
 * ⚠️ Script nay nam trong ruot ngan keo gio. Ruot gio duoc theme THAY LAI bang HTML
 *    moi (thayRuot) nen the <script> co the bi go khoi DOM — nhung module da nap roi
 *    va trinh nghe su kien gan tren `document` VAN CON. Vi vay moi lan chay deu
 *    PHai TU TIM LAI khoi ma trong DOM (khong giu tham chieu cu).
 */
(function () {
  'use strict';

  /** Co do popup (assets/bamboove-newsletter-popup.js) ghi khi khach de lai email. */
  var KHOA_DA_DANG_KY = 'bamboove-popup-da-dang-ky';
  /** Su kien gio doi — giong danh sach theme dang dung (bamboove-cart-drawer.js). */
  var SU_KIEN_GIO = ['shopify:cart:lines-update', 'cart:lines-update', 'cart:update'];

  var dangChay = false;

  function docCo() {
    try {
      return localStorage.getItem(KHOA_DA_DANG_KY) === '1';
    } catch (e) {
      return false; /* che do rieng tu: coi nhu chua de email */
    }
  }

  function ghiCo() {
    try {
      localStorage.setItem(KHOA_DA_DANG_KY, '1');
    } catch (e) {
      /* bo qua */
    }
  }

  /**
   * Trang nay co dau "dang ky thanh cong" khong?
   * (de khach dang ky o CHAN TRANG / dai email — nhung trang khong nap popup —
   *  van duoc ghi co, khong phai de email lai lan nua)
   */
  function coDauThanhCong() {
    return !!(document.querySelector('.bamboove-np__ok[role="status"]') ||
      document.querySelector('.bamboove-eb__ok[role="status"]') ||
      document.querySelector('[id^="Email-signup__message-success-"]'));
  }

  function timKhoiMa() {
    return document.querySelector('#cart-drawer [data-bb-gio-ma]');
  }

  function layGio() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function daApMa(gio, ma) {
    var ds = (gio && gio.discount_codes) || [];
    var tren = ma.toUpperCase();
    for (var i = 0; i < ds.length; i++) {
      if (String(ds[i].code || '').toUpperCase() === tren && ds[i].applicable) return true;
    }
    return false;
  }

  async function apMa() {
    var khoi = timKhoiMa();
    if (!khoi || !khoi.dataset.bbMa) return; /* ngan keo gio khong co khoi ma => thoi */
    var ma = khoi.dataset.bbMa;

    /* (1) Chua de email => khong hien khoi ma, khong lam gi. */
    if (!docCo() && !coDauThanhCong()) {
      khoi.hidden = true;
      return;
    }
    if (coDauThanhCong()) ghiCo();

    if (dangChay) return;
    dangChay = true;
    try {
      var gio = await layGio();

      /* (2) Gio trong => chua ap; an khoi (khong chiem dien tich khi gio dang trong). */
      if (!gio.item_count) {
        khoi.hidden = true;
        return;
      }

      /* (3) Da ap roi => an khoi, thoi. */
      if (daApMa(gio, ma)) {
        khoi.hidden = true;
        return;
      }

      /* (4) Chua ap => tu ap. */
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: ma }),
      });
      var moi = await layGio();

      if (daApMa(moi, ma)) {
        khoi.hidden = true; /* ap duoc => AN (khach yeu cau: ap xong thi an di) */
        /* Ve lai ruot gio de phan tong tien hien dong giam gia (ten uu dai that). */
        if (window.bambooveGio && typeof window.bambooveGio.veLai === 'function') {
          window.bambooveGio.veLai();
        }
      } else {
        /* Shopify khong ap (thuong la uu dai bundle da loi hon) => an luon, khong hua gi. */
        khoi.hidden = true;
      }
    } catch (e) {
      /* Mang loi: hien khoi du phong de khach van tu ap duoc (co nut Copy/Apply). */
      khoi.hidden = false;
    } finally {
      dangChay = false;
    }
  }

  function chay() {
    apMa();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }

  /* Gio doi (them/bot mon, doi so luong) => xet lai (co chan chong lap ben trong). */
  for (var i = 0; i < SU_KIEN_GIO.length; i++) {
    document.addEventListener(SU_KIEN_GIO[i], chay);
  }

  /* Trinh soan theme: khoi duoc nap lai => xet lai. */
  document.addEventListener('shopify:section:load', chay);
})();
